import React from "react";
import "./BuildingBlocks.css";

const blocks = [
  {
    title: "100% Qualität",
    points: [
      "Exakte Reinigungspläne und LV für Transparenz",
      "Einsatz von ausgezeichneten Profi-Produkten",
      "Qualitätskontrollen für konstant gute Reinigungsergebnisse",
    ],
  },
  {
    title: "100% Service",
    points: [
      "24 h Erreichbarkeit bei Notfällen",
      "Stabiler Personalpool für Ihre Zufriedenheit",
      "Eine professionell ausgebildete Kundenbetreuung ist Ihr Ansprechpartner",
    ],
  },
  {
    title: "100% Hygiene",
    points: [
      "Umsetzung eines bewährten Hygienekonzepts",
      "Protokolle zur Qualitätssicherung",
      "100%-ige Vermeidung von Keimverschleppung durch EMR 360° Methode",
    ],
  },
];

const BuildingBlocks = () => (
  <section className="blocks-section">
    <h2>Bei uns kommt es auf drei Bausteine an</h2>
    <div className="block-grid">
      {blocks.map((b, i) => (
        <div className="block-card" key={i}>
          <ul>
            {b.points.map((p, j) => (
              <li key={j}>{p}</li>
            ))}
          </ul>
          <div className="block-title">{b.title}</div>
        </div>
      ))}
    </div>
  </section>
);

export default BuildingBlocks;
